// extracted by mini-css-extract-plugin
export default {"logoAndTitle":"logoAndTitle___ogfwF","title":"title___Cvl1p"};